
export { default as CloseSvg } from '../../Design/Icons/close.svg';
export { default as MenuSvg } from '../../Design/Icons/menu.svg';
export { default as SearchSvg } from '../../Design/Icons/search.svg';

export { default as sandwichJpg } from '../../Design/Images/sandwich.jpg';
export { default as LogoSvg } from '../../Design/Images/logo.svg';
